import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const PortalContext = React.createContext(null);

export const PortalProvider = ({ children }) => {
  const [portalRoot, setPortalRoot] = useState(null);
  const theme = useSelector(state => state.application.theme);

  useEffect(() => {
    let root = document.getElementById("portal-root");
    const created = !root;
    if (!root) {
      root = document.createElement("div");
      root.id = "portal-root";
      document.body.appendChild(root);
    }
    // Apply current theme immediately so first render inherits correct variables
    const themeName = (theme || "light").toLowerCase();
    
    // TODO: Change to themeName when we have a light theme
    root.setAttribute("data-theme", "dark");
    root.className = `theme-aware theme-${themeName}`;
    setPortalRoot(root);

    return () => {
      if (created && root && root.parentNode) {
        document.body.removeChild(root);
      }
    };
  }, [theme]);

  useEffect(() => {
    if (portalRoot) {
      portalRoot.setAttribute("data-theme", theme.toLowerCase());
      portalRoot.className = `theme-aware theme-${theme.toLowerCase()}`;
    }
  }, [theme, portalRoot]);

  return (
    <PortalContext.Provider value={portalRoot}>
      {children}
    </PortalContext.Provider>
  );
};

export const usePortal = () => React.useContext(PortalContext);
